import http from '../../../../../lib/http'
import { notify } from '../../../../../lib/Notification/actions.js'
import { unmap } from '../../../../../lib/Proxy/insurance.js'
import { compartmentReceive } from '../../../patientActions.js'

export const INSURANCE = 'INSURANCE'
export const INSURANCE_SUCCESS = 'INSURANCE_SUCCESS'
export const INSURANCE_FAILURE = 'INSURANCE_FAILURE'

export const ADD_INSURANCE = 'ADD_INSURANCE'
export const ADD_INSURANCE_SUCCESS = 'ADD_INSURANCE_SUCCESS'
export const ADD_INSURANCE_FAILURE = 'ADD_INSURANCE_FAILURE'

export const UPDATE_INSURANCE = 'UPDATE_INSURANCE'
export const UPDATE_INSURANCE_SUCCESS = 'UPDATE_INSURANCE_SUCCESS'
export const UPDATE_INSURANCE_FAILURE = 'UPDATE_INSURANCE_FAILURE'

export const DELETE_INSURANCE = 'DELETE_INSURANCE'
export const DELETE_INSURANCE_SUCCESS = 'DELETE_INSURANCE_SUCCESS'
export const DELETE_INSURANCE_FAILURE = 'DELETE_INSURANCE_FAILURE'

export const INSURANCE_ISSUE_CHECK = 'INSURANCE_ISSUE_CHECK'

export const insuranceIssueCheck = () => ({
  type: INSURANCE_ISSUE_CHECK
})

export const getInsurance = patientId => dispatch => {
  dispatch({ type: INSURANCE })
  return http
    .getRequest(`/patients/${patientId}/insurance`)
    .then(data => {
      dispatch(compartmentReceive(patientId))
      dispatch({
        type: INSURANCE_SUCCESS,
        result: data.map(d => unmap(d.resource))
      })
    })
    .catch(err =>
      dispatch({
        type: INSURANCE_FAILURE,
        err
      }))
}

export const updateInsurance =
  (patientId, insuranceId, formData) => dispatch => {
    dispatch({ type: UPDATE_INSURANCE })
    return http
      .putRequest(`/patients/${patientId}/insurance/${insuranceId}`, formData)
      .then(data => {
        dispatch(notify('Insurance updated successfully', false))
        dispatch({
          type: UPDATE_INSURANCE_SUCCESS,
          data
        })
        dispatch(getInsurance(patientId))
      })
      .catch(err =>
        dispatch({
          type: UPDATE_INSURANCE_FAILURE,
          error: err
        }))
  }

export const addInsurance = (patientId, formData) => dispatch => {
  dispatch({ type: ADD_INSURANCE })
  return http
    .postRequest(`/patients/${patientId}/insurance`, formData)
    .then(data => {
      dispatch(notify('Insurance saved successfully', false))
      dispatch({
        type: ADD_INSURANCE_SUCCESS,
        data
      })
      dispatch(getInsurance(patientId))
    })
    .catch(err =>
      dispatch({
        type: ADD_INSURANCE_FAILURE,
        error: err
      }))
}

export const deleteInsurance = (patientId, insuranceId) => dispatch => {
  dispatch({ type: DELETE_INSURANCE })
  return http
    .deleteRequest(`/patients/${patientId}/insurance/${insuranceId}`)
    .then(() => {
      dispatch(notify('Insurance was deleted', false))
      dispatch({
        type: DELETE_INSURANCE_SUCCESS
      })
      dispatch(getInsurance(patientId))
    })
    .catch(err =>
      dispatch({
        type: DELETE_INSURANCE_FAILURE,
        error: err
      }))
}
